function stopIframe(iframe) {
    var newSrc = iframe.src;
    newSrc = newSrc.replace('&autoplay=1', '');
    iframe.src = '';
    setTimeout(function () {
        iframe.src = newSrc;
    }, 1000);
}

$('.video-modal').on('shown.bs.modal', function(e) {
    let iframe = $(this).find('iframe')[0],
        src = iframe.src;

    if (src.indexOf('&autoplay=1') === -1) {
        iframe.src = src + '&autoplay=1&mute=1';
    }
});

$('figure.iframe-video').each(function() {
    let iframe = $(this).find('iframe'),
        ratio = iframe.attr('height') / iframe.attr('width');
    $(this).css('padding-bottom', ratio * 100 + '%');
});

$('.video-modal').on('hide.bs.modal', function(e) {
    let iframe = $(this).find('iframe')[0];

    stopIframe(iframe);
});